import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapDrawerLocation from '../enums/MapDrawerLocation';
import MapLocation from '../enums/MapLocation';

type logMapBaseLayerListExpandedParams = {
  map_drawer_location?: MapDrawerLocation;
  map_location: MapLocation;
};

/**
 * A user taps the "More" chip in the map layer menu to reveal the base maps that are hidden behind it. Only the two prominent base maps are shown until this happens, so this event gates discovery of every other base map.
 * @param params - Attributes to log with the amplitude event
 * @param params.map_drawer_location - The drawer tab that the base map list was in.
 * @param params.map_location - The location of the map where the interaction occurred
 */
const logMapBaseLayerListExpanded = ({ map_drawer_location, map_location }: logMapBaseLayerListExpandedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'map base layer list expanded',
    { 'map drawer location': map_drawer_location, 'map location': map_location },
    callback
  );
};

export default logMapBaseLayerListExpanded;
